import { Flex, RemoteImage, Typography } from '@banhala/ui-kit';
import type { FavoriteMarketWithNewGoods } from 'shared/src/api/favoriteMarketService/getFavoriteMarketsWithNewGoods/types';

export const MARKET_ITEM_WIDTH = 64;
export const MARKET_AVATAR_SIZE = 52;

interface MarketItemProps {
  market: FavoriteMarketWithNewGoods;
  index: number;
  onPress: () => void;
}

export const MarketItem = ({ market, index, onPress }: MarketItemProps) => {
  const showBadge = market.new_goods_count > 0;

  return (
    <Flex
      width={MARKET_ITEM_WIDTH}
      alignItems={'center'}
      onPress={onPress}
      testID={`찜한마켓?index=${index}&value=${market.name}`}
    >
      <Flex>
        <Flex.Center
          width={MARKET_AVATAR_SIZE}
          height={MARKET_AVATAR_SIZE}
          borderRadius={MARKET_AVATAR_SIZE / 2}
          borderWidth={1}
          borderColor={'border_transparent'}
          overflow={'hidden'}
        >
          <RemoteImage
            uri={market.image}
            width={MARKET_AVATAR_SIZE}
            height={MARKET_AVATAR_SIZE}
            doAnimate={false}
          />
        </Flex.Center>
        {showBadge && <NewGoodsBadge count={market.new_goods_count} />}
      </Flex>
      <Flex padding={{ top: 6 }}>
        <Typography
          type={'body3'}
          color={'content_secondary'}
          numberOfLines={1}
          ellipsizeMode={'tail'}
          textAlign={'center'}
        >
          {market.name}
        </Typography>
      </Flex>
    </Flex>
  );
};

const NewGoodsBadge = ({ count }: { count: number }) => (
  <Flex.Center
    position={'absolute'}
    top={0}
    right={0}
    height={18}
    minWidth={22}
    padding={{ horizontal: 4 }}
    borderRadius={9}
    backgroundColor={'bg_black_button'}
  >
    <Typography type={'subtitle6'} color={'content_always_white'}>
      {`+${Math.min(count, 99)}`}
    </Typography>
  </Flex.Center>
);
